import React from 'react';
import startCase from 'lodash/startCase';
import capitalize from 'lodash/capitalize';
import { ResponsiveBar } from '@nivo/bar'
import { max, sum, rollup, group } from 'd3-array';
import { format } from 'd3-format';
import { timeParse, timeFormat } from 'd3-time-format';
import { Classes } from "@blueprintjs/core";

import './NivoBarChart.scss';

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.

// const flatten = arrays => [].concat.apply([], arrays);
const keyValueToObj = arr => arr.reduce((acc, obj) => ({
  ...acc,
  [obj.key]: obj.value
}), {});



const NivoBarChart = ({ features, group_prop, aggProp, colorProp, color, setColorProp, uniquePropsMap, filterProp, setFilterProp }) => {
  const skeletonClass = features.length === 0 ? Classes.SKELETON : '';
  const agg = fs => sum(fs, f => f.properties[aggProp]);
  const key1 = f => f.properties[group_prop] || ""; // remove nulls
  const key2 = f => f.properties[colorProp] || "" // remove nulls
  const toDict = ([key, value]) => ({ key, value });

  const sortByKey = (a, b) => {
    if (a.group_prop < b.group_prop) return -1;
    if (a.group_prop > b.group_prop) return 1;
    return 0;
  }
  if (uniquePropsMap[group_prop] === undefined) return null;
  const isSelectedChart = group_prop === colorProp;
  // const data = Array.from(rollup(features, agg, key1), toDict).sort(sortByKey);
  const rolled = rollup(features, agg, key1, key2);
  // make nivo format
  const data = uniquePropsMap[group_prop].map(prop => {
    const key1s = rolled.get(prop);
    if (!key1s) return { prop, [prop]: 0 }
    // return Array.from(key1s, ([colorProp, value]) => ({ prop, colorProp, value}));
    const byColorArr = Array.from(key1s, toDict);

    if (isSelectedChart) {
      return { prop, ...keyValueToObj(byColorArr) }
    }
    else if (filterProp) {
      // TODO use rollup rather than group and sum
      const splitByFilter = group(byColorArr, g => g.key === filterProp)
      if (splitByFilter.size !== 2) return { prop, [prop]: 0 };
      return {
        prop,
        [filterProp]: sum(splitByFilter.get(true).map(g => g.value)),
        'Remainder': sum(splitByFilter.get(false).map(g => g.value))
      }
    }
    else {
      return {
        prop,
        [prop]: sum(byColorArr.map(g => g.value))
      }
    }
  }).sort(sortByKey)

  // TODO labelFormat and tooltip $ not always?
  // TODO dirty hack
  let tickFormat = a => a;
  if (data[0]?.prop?.slice(0, 5) === "time:") {
    const parser = timeParse("time:%Y-%m-%d");
    const formatter = timeFormat('%b %y');
    tickFormat = a => formatter(parser(a));
  }
  // TODO more generic?
  let dosh = '';
  if (aggProp.toLowerCase().includes('cost')) {
    dosh = '$';
  }


  const barWidth = 20;
  const bottomMargin = 3;
  const leftMargin = 105;
  return (
    <div
      onClick={evt => {
        setColorProp(group_prop);
        (filterProp && !(filterProp in uniquePropsMap[group_prop])) && setFilterProp(undefined);
      }}
    >
      <h5
        className={["bp3-heading", "bp3-text-overflow-ellipsis", skeletonClass].join(' ')}
        style={{
          padding: 6,
          margin: 0,
          marginTop: 6,
          color: isSelectedChart ? 'black' : '#656565',
          textDecoration: isSelectedChart ? 'none' : 'underline',
          cursor: isSelectedChart ? 'auto' : 'pointer'
        }}
      >
        {capitalize(startCase(group_prop.slice(0, 20)))}
      </h5>
      <div className={skeletonClass} style={{ height: barWidth * data.length, cursor: 'pointer' }}>
        <ResponsiveBar
          layout='horizontal'
          onClick={(bar, evt) => {
            console.log(bar);
            evt.stopPropagation();
            setColorProp(group_prop);
            setFilterProp(bar.indexValue);
          }}
          data={data}
          keys={(isSelectedChart || !filterProp) ? uniquePropsMap[group_prop] : [filterProp, 'Remainder']}
          indexBy={'prop'}
          margin={{ top: 0, right: 3, bottom: bottomMargin, left: leftMargin }}
          colors={r => {
            return isSelectedChart || r.id === filterProp
              ? color(r.id)
              : "#d5d5d5";
          }}
          // label={({ id, value }) => `${id}: ${${format(dosh + '.0s')(value)}}`}
          labelFormat={dosh + '.2s'}
          axisTop={null}
          axisRight={null}
          axisBottom={null}

          // axisBottom={{
          //   renderTick: r => {
          //     return <foreignObject
          //       key={r.value}
          //       width={bottomMargin}
          //       height={barWidth}
          //       transform={`translate(${r.x - (barWidth / 2)} ${0}) rotate(-90) translate( ${-bottomMargin} ${0})`}
          //     >
          //       <div style={{
          //         width: bottomMargin,
          //         height: barWidth,
          //         display: 'flex',
          //         alignItems: 'center',
          //         justifyContent: 'flex-end'
          //       }}>

          //         <p
          //           xmlns="http://www.w3.org/1999/xhtml"
          //           style={{
          //             margin: 0,
          //             marginRight: 4,
          //             fontFamily: 'sans-serif',
          //             fontSize: 10,
          //             lineHeight: '0.65rem',
          //             textAlign: 'end',
          //           }}
          //         >
          //           {tickFormat(r.value)}
          //         </p>
          //       </div>
          //     </foreignObject>
          //   }
          // }}
          axisLeft={{
            renderTick: r => {
              return <foreignObject
                key={r.value}
                width={leftMargin}
                height={barWidth}
                transform={`translate(${-leftMargin} ${r.y - (barWidth / 2)})`}
              >
                <div style={{
                  width: leftMargin,
                  height: barWidth,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end'
                }}>

                  <p
                    xmlns="http://www.w3.org/1999/xhtml"
                    style={{
                      margin: 0,
                      marginRight: 4,
                      fontFamily: 'sans-serif',
                      fontSize: 10,
                      lineHeight: '0.65rem',
                      textAlign: 'end',
                    }}
                  >
                    {tickFormat(r.value)}
                  </p>
                </div>
              </foreignObject>
            }
          }}
          tooltip={({ id, value }) =>
            <span>
              {`${id}: ${format(dosh + '.2s')(value)}`}
            </span>
          }
          labelSkipWidth={30}
          labelSkipHeight={12}
          animate={true}
          enableGridY={false}
        />
      </div>
    </div >
  )
}

export default NivoBarChart;